module.exports = {
      id: "marginnote-icon-search-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "images/js_src_vue/page_marginnote_landing/sprite.20f12c2e.svg#marginnote-icon-search-usage",
      toString: function () {
        return this.url;
      }
    }